import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const DeleteBottleSizeIcon: FC<IconProps> = (props) => {
  const {
    size = 16,
    color = 'currentColor'
  } = props
  return <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2.80062 11.1894C2.59351 10.8307 2.71642 10.372 3.07514 10.1649L12.1684 4.91493C12.5271 4.70782 12.9858 4.83073 13.1929 5.18945C13.4 5.54817 13.2771 6.00686 12.9184 6.21396L3.82514 11.464C3.46642 11.6711 3.00772 11.5482 2.80062 11.1894Z'
      fill={color}
    />
    <path
      d='M7.15479 2.21545V2.85729L8.83829 2.85729V2.21545C8.83829 2.09643 8.74753 2 8.63161 2L7.36098 2C7.24704 2 7.15479 2.09542 7.15479 2.21545Z'
      fill={color}
    />
    <path
      d='M7.15478 4.4393V3.2857H8.83829L8.83829 4.4393C8.83829 4.64342 9.00551 4.75571 9.21825 4.89857C9.59012 5.1483 10.1011 5.49143 10.1011 6.58176V7.84045L5.89198 10.2706V6.58176C5.89198 5.49144 6.40294 5.14832 6.77481 4.8986C6.98755 4.75574 7.15478 4.64344 7.15478 4.4393Z'
      fill={color}
    />
    <path
      d='M5.89198 12.0026V13.1427C5.89198 13.6163 6.27131 14 6.73746 14H9.25561C9.72274 14 10.1011 13.6143 10.1011 13.1427V9.57249L5.89198 12.0026Z'
      fill={color}
    />
    <circle cx='8' cy='8' r='7.5' stroke={color} />
  </svg>
}

export default DeleteBottleSizeIcon
